<template>
    <div class="layout">
      <!-- Barra lateral -->
      <aside class="sidebar">
        <h2>
          <router-link to="/" class="site-title">Utilitários Diversos</router-link>
        </h2>
        <nav>
          <ul>
            <li><router-link to="/">🏠 Home</router-link></li>
  
            <li>
              <span @click="toggleMenu('texto')">📝 TEXTO ▼</span>
              <ul v-show="openMenus.texto">
                <li><router-link to="/uppercase">Converter para Maiúsculas</router-link></li>
                <li><router-link to="/lowercase">Converter para Minúsculas</router-link></li>
                <li><router-link to="/sort">Ordenar</router-link></li>
                <li><router-link to="/remove-duplicates">Remover Duplicados</router-link></li>
              </ul>
            </li>
            
            <li>
              <span @click="toggleMenu('resumos')">📚 RESUMOS ▼</span>
              <ul v-show="openMenus.resumos">
                <li><router-link to="/git-cheatsheet">Git CheatSheet</router-link></li>
                <li><router-link to="/linux-cheatsheet">Linux CheatSheet</router-link></li>
                <li><router-link to="/sql-cheatsheet">SQL CheatSheet</router-link></li>
                <li><router-link to="/markdown-cheatsheet">Markdown CheatSheet</router-link></li>
              </ul>
            </li>
  
            <li>
              <span @click="toggleMenu('imagens')">🖼️ IMAGENS ▼</span>
              <ul v-show="openMenus.imagens">
                <li><router-link to="/qrcode-generator">Gerador de QR Code</router-link></li>
              </ul>
            </li>
  
            <li><router-link to="/calendar">📅 Calendário</router-link></li>
          </ul>
        </nav>
  
        <!-- Símbolo ∴ com tooltip -->
        <div class="footer">
          <span class="symbol" title="Eu trabalho do meio-dia a meia-noite">∴</span>
        </div>
      </aside>
  
      <!-- Conteúdo principal -->
      <main class="main-content">
        <router-view></router-view>
      </main>
    </div>
  </template>
  
  <script>
  export default {
    name: "SidebarLayout",
    data() {
      return {
        openMenus: {
          texto: true,
          resumos: true,
          imagens: true,
        },
      };
    },
    methods: {
      toggleMenu(menu) {
        this.openMenus[menu] = !this.openMenus[menu];
      },
    },
  };
  </script>
  
  <style scoped>
  .layout {
    display: flex;
    height: 100vh;
  }
  
  .sidebar {
    width: 250px;
    background-color: #0056b3;
    color: white;
    padding: 20px;
    font-family: Arial, sans-serif;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .site-title {
    color: #ffcc00; /* Cor diferenciada */
    text-align: center;
    display: block;
    font-size: 20px;
    text-decoration: none;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .sidebar nav {
    flex-grow: 1;
  }
  
  .sidebar ul {
    list-style-type: none;
    padding: 0;
  }
  
  .sidebar li {
    margin: 10px 0;
  }
  
  .sidebar span {
    font-weight: bold;
    cursor: pointer;
    display: block;
    padding: 5px 0;
  }
  
  .sidebar ul ul {
    padding-left: 20px;
  }
  
  .sidebar a {
    text-decoration: none;
    color: white;
    display: block;
    padding: 5px 0;
  }
  
  .sidebar a:hover {
    text-decoration: underline;
  }
  
  .footer {
    text-align: center;
    margin-top: 20px;
  }
  
  .symbol {
    font-size: 14px;
    cursor: help;
    display: inline-block;
  }
  </style>
  